<script>
import ImageProxy from '@/components/ImageProxy.vue';
import RowFilters from '@/components/RowFilters.vue';

export default {
  name: 'Campaigns',
  components: {
    RowFilters,
    ImageProxy,
  },
  data() {
    return {
      isLoading: false,
      serverParams: {
        columnFilters: {},
        sort: {
          field: 'id',
          type: 'desc',
        },
        page: 1,
        perPage: 10,
      },
      rows: [],
      serverMetadata: {
        total: 0,
        feeds: [],
        formats: [],
      },
    };
  },
  computed: {
    columns(t) {
      return [
        {
          label: 'ID',
          field: 'id',
          type: 'number',
          hidden: false,
          checked: true,
          disabled: true,
        },
        {
          label: 'Статус',
          field: 'status',
          hidden: false,
          checked: true,
          disabled: true,
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'Все',
            filterDropdownItems: [
              {
                value: 'active',
                text: 'Активные',
              },
              {
                value: 'blocked',
                text: 'Заблокированные',
              },
            ],
          },
        },
        {
          label: 'Формат',
          field: 'format',
          hidden: false,
          checked: true,
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'Все',
            filterDropdownItems: t.formats.map(f => ({
              value: f.value,
              text: f.label,
            })),
          },
        },
        {
          label: 'Фид',
          field: 'feedId',
          hidden: false,
          checked: true,
          sortable: false,
          filterOptions: {
            customFilter: true,
          },
        },
        {
          label: 'ID кампании',
          field: 'campaignId',
          type: 'number',
          hidden: false,
          checked: true,
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'Все',
            filterValue: '',
            trigger: 'enter',
          },
        },
        {
          label: 'Иконка',
          field: 'parsedIconUrl',
          hidden: false,
          checked: true,
          sortable: false,
        },
        {
          label: 'Изображение',
          field: 'parsedImageUrl',
          hidden: false,
          checked: true,
          sortable: false,
        },
        {
          label: 'Заголовок',
          field: 'title',
          hidden: false,
          checked: true,
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'Все',
            filterValue: '',
            trigger: 'enter',
          },
        },
        {
          label: 'Текст',
          field: 'text',
          hidden: false,
          checked: true,
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'Все',
            filterValue: '',
            trigger: 'enter',
          },
        },
        {
          label: 'URL',
          field: 'url',
          hidden: false,
          checked: true,
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'Все',
            filterValue: '',
            trigger: 'enter',
          },
        },
        {
          label: 'Страница',
          field: 'parsedPageUrl',
          hidden: false,
          checked: true,
          sortable: false,
        },
        {
          label: 'Действия',
          field: 'actions',
          hidden: false,
          checked: true,
          sortable: false,
        },
      ];
    },
    defaultFilters() {
      return [
        {
          id: 'country',
          defaultValue: '',
          items: [
            {
              label: 'Все страны',
              value: '',
            },
            ...(this.serverMetadata.countries || []),
          ],
        },
        {
          id: 'browser',
          defaultValue: '',
          items: [
            {
              label: 'Все браузеры',
              value: '',
            },
            ...(this.serverMetadata.browsers || []),
          ],
        },
        {
          id: 'os',
          defaultValue: '',
          items: [
            {
              label: 'Все системы',
              value: '',
            },
            ...(this.serverMetadata.os || []),
          ],
        },
        {
          id: 'user',
          defaultValue: '',
          items: [
            {
              label: 'Все пользователи',
              value: '',
            },
            ...(this.serverMetadata.users || []),
          ],
        },
        {
          id: 'site',
          defaultValue: '',
          items: [
            {
              label: 'Все площадки',
              value: '',
            },
            ...(this.serverMetadata.sites || []),
          ],
        },
        {
          id: 'device',
          defaultValue: '',
          items: [
            {
              label: 'Все устройства',
              value: '',
            },
            ...(this.serverMetadata.devices || []),
          ],
        },
      ];
    },
    feeds() {
      return this.serverMetadata.feeds;
    },
    formats() {
      return this.serverMetadata.formats;
    },
  },
  async created() {
    this.loadItems();
  },
  methods: {
    /**
     *
     * @return {Boolean}
     */
    updateParams(newParams) {
      this.serverParams = Object.assign({}, this.serverParams, newParams);
      return true;
    },

    onPageChange(params) {
      if (this.updateParams({ page: params.currentPage })) {
        this.loadItems();
      }
    },

    onPerPageChange(params) {
      if (this.updateParams({ perPage: params.currentPerPage })) {
        this.loadItems();
      }
    },

    onSortChange(params) {
      if (this.updateParams({
        sort: params.length > 0 ? {
          field: params[0].field,
          type: params[0].type === 'none' ? 'asc' : params[0].type,
        } : undefined,
      })) {
        this.loadItems();
      }
    },

    /**
     * @typedef {Object} params
     * @property {string} campaignId
     * @property {string} title
     * @property {string} text
     * @property {string} url
     * @property {string} feedId
     */
    onColumnFilter(params) {
      if (this.updateParams({
        columnFilters: {
          ...this.serverParams.columnFilters,
          ...params.columnFilters,
        },
      })) {
        this.loadItems();
      }
    },

    loadItems() {
      this.isLoading = true;
      this.$api.getCampaigns(this.serverParams).then(res => {
        this.rows = res.data;
        if (this.serverMetadata.feeds.length === 0 && this.serverMetadata.formats.length === 0) {
          this.serverMetadata = res.metadata;
        }
        this.serverMetadata.total = res.metadata.total;
      }).catch(e => {
        this.$notification.error(e.message);
      }).finally(() => {
        this.isLoading = false;
      });
    },

    blockCampaign({
      id,
      campaignId,
      feedName,
    }) {
      this.$api.blockCampaign(id)
          .then(res => {
            this._updateCampaignRowStatus(id, res.status);
            this.$notification.info(`Кампания ${campaignId} фида ${feedName} заблокирована`);
          })
          .catch(e => {
            console.error(e);
            this.$notification.error(e.message);
          });
    },

    unblockCampaign({
      id,
      campaignId,
      feedName,
    }) {
      this.$api.unblockCampaign(id)
          .then(res => {
            this._updateCampaignRowStatus(id, res.status);
            this.$notification.info(`Кампания ${campaignId} фида ${feedName} разблокирована`);
          })
          .catch(e => {
            console.error(e);
            this.$notification.error(e.message);
          });
    },

    _updateCampaignRowStatus(id, status) {
      this.rows.forEach((row) => {
        if (row.id === id) {
          row.status = status;
        }
      });
    },

    onTopFiltersChange(filters) {
      if (this.updateParams({
        columnFilters: {
          ...this.serverParams.columnFilters,
          ...filters,
        },
      })) {
        this.loadItems();
      }
    },
  },
};
</script>

<template>
  <div>
    <div>
      <RowFilters :filters="defaultFilters" @change="onTopFiltersChange" />
    </div>

    <div class="table-container">
      <vue-good-table
          styleClass="vgt-table table table-stat vgt-table-odd-even"
          :columns="columns"
          :rows="rows"
          :totalRows="serverMetadata.total"
          mode="remote"
          compactMode
          @on-page-change="onPageChange"
          @on-sort-change="onSortChange"
          @on-column-filter="onColumnFilter"
          @on-per-page-change="onPerPageChange"
          :isLoading.sync="isLoading"
          :pagination-options="{
            enabled: true,
            perPage: 10,
            perPageDropdown: [10, 25, 50, 100],
            dropdownAllowAll: false,
            jumpFirstOrLast : true,
            rowsPerPageLabel: 'Строк на странице',
            allLabel: 'Все',
            ofLabel: 'из',
            prevLabel: 'Назад',
            nextLabel: 'Вперед',
            firstLabel : 'В начало',
            lastLabel : 'В конец',
        }"
      >
        <template slot="column-filter" slot-scope="{column,updateFilters}">
          <v-select
              class="feeds-select"
              v-if="column.filterOptions && column.filterOptions.customFilter"
              :options="feeds"
              :reduce="feed => feed.value"
              @input="(value) => updateFilters(column, value || '')"
              label="label"
              :clearable="true"
              :searchable="true"
          />
        </template>

        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'feedId'">
            <router-link class="link" :to="{ name: 'FeedId', params: { id: props.row.feedId }}">{{ props.row.feedName }}</router-link>
          </span>
          <span v-else-if="props.column.field === 'status'">
            <span v-if="props.row.status === 'active'" class="status status-active">Активно</span>
            <span v-else-if="props.row.status === 'blocked'" class="status status-blocked">Заблокировано</span>
            <span v-else>{{ props.row.status }}</span>
          </span>
          <span v-else-if="props.column.field === 'campaignId'" :title="`Реальный ID: ${props.row.originalCampaignId}`">
            {{ props.row.campaignId }}
          </span>
          <span v-else-if="props.column.field === 'parsedIconUrl'">
            <a :href="props.row.parsedIconUrl" target="_blank" v-if="props.row.parsedIconUrl" title="Parsed icon">
              <img :src="props.row.parsedIconUrl" alt="icon" class="image">
            </a>
            <image-proxy v-else-if="props.row.iconUrl" :src="props.row.iconUrl" alt="Original icon" title="Original icon" />
            <span v-else>-</span>
          </span>
          <span v-else-if="props.column.field === 'parsedImageUrl'">
            <a :href="props.row.parsedImageUrl" target="_blank" v-if="props.row.parsedImageUrl" title="Parsed image">
              <img :src="props.row.parsedImageUrl" alt="image" class="image">
            </a>
            <image-proxy v-else-if="props.row.imageUrl" :src="props.row.imageUrl" alt="Original image" title="Original image" />
            <span v-else>-</span>
          </span>
          <span v-else-if="props.column.field === 'parsedPageUrl'">
            <a :href="props.row.parsedPageUrl" target="_blank" v-if="props.row.parsedPageUrl">
              <img :src="props.row.parsedPageUrl" alt="page" class="image">
            </a>
            <span v-else>-</span>
          </span>
          <span v-else-if="props.column.field === 'url'">
            <a target="_blank" :href="props.row.url" class="truncate-text">{{ props.row.url }}</a>
          </span>
          <span v-else-if="props.column.field === 'title'" class="text-left wrap-text">{{ props.row.title || '-' }}</span>
          <span v-else-if="props.column.field === 'text'" class="text-left wrap-text">{{ props.row.text || '-' }}</span>
          <span v-else-if="props.column.field === 'actions'">
            <template v-if="props.row.status === 'active'">
              <button @click="blockCampaign(props.row)">Заблокировать</button>
            </template>
            <template v-else-if="props.row.status === 'blocked'">
              <button @click="unblockCampaign(props.row)">Разблокировать</button>
            </template>
          </span>
          <span v-else v-html="props.formattedRow[props.column.field]"></span>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<style scoped>
.image {
  max-height: 80px;
}

.text-left {
  text-align: left;
  justify-content: flex-start;
  display: flex;
}

.wrap-text {
  width: 160px;
  white-space: normal;
  word-wrap: break-word;
}

.truncate-text {
  display: inline-block;
  width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.feeds-select {
  margin-bottom: 0;
  width: 100%;
}

.status {
  color: #fff;
  padding: 3px 5px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 12px;
}

.status-active {
  background-color: #1f9d1f;
}

.status-blocked {
  background-color: #ff0900;
}
</style>
